import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconCard = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <rect x="1" y="1" width="18" height="13" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <path d="M1 5H18.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M4 9H8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export default IconCard
